import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=6303b523"
import script from "./messageInfo.vue?vue&type=script&lang=js"
export * from "./messageInfo.vue?vue&type=script&lang=js"
import style0 from "./messageInfo.vue?vue&type=style&index=0&id=6303b523&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports